module.exports = __webpack_public_path__ + "img/Speaker=Omna Toshniwal.0546aeab.png";